// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2bxNs","colBig":"styles_colBig__1_-rW","colSmall":"styles_colSmall__2QOSB"};